/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} For_Whom_Tag_ConsultsInputs */

const en_for_whom_tag_consults = /** @type {(inputs: For_Whom_Tag_ConsultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Consultations`)
};

const pl_for_whom_tag_consults = /** @type {(inputs: For_Whom_Tag_ConsultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Konsultacje`)
};

/**
* | output |
* | --- |
* | "Consultations" |
*
* @param {For_Whom_Tag_ConsultsInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const for_whom_tag_consults = /** @type {((inputs?: For_Whom_Tag_ConsultsInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<For_Whom_Tag_ConsultsInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_for_whom_tag_consults(inputs)
	return en_for_whom_tag_consults(inputs)
});